module.exports = __webpack_public_path__ + "static/media/gls.af943797.png";